module.exports = __webpack_public_path__ + "img/top-title.18d93113.png";